import {
  RATE_PER_DAY,
  TWO_DAY_DISCOUNT,
  THREE_DAY_EXTRA_DISCOUNT,
  FOUR_DAY_EXTRA_DISCOUNT,
} from "./config";

// Price a booking. `sets` holds the number of sets per day; consecutive-day
// discounts apply per set, so e.g. [1, 2, 2, 1] prices one set at the 4-day
// rate and the second Sat/Sun set at the 2-day rate.
export const priceBooking = (sets) => {
  const totals = sets.map((s) => s * RATE_PER_DAY);
  const discounts = sets.map((s, i) => {
    const o = (offset) => sets[i + offset] || 0;
    const twoDay = Math.max(o(+1), o(-1));
    const threeDay = Math.max(
      Math.min(o(+2), o(+1), s),
      Math.min(o(-1), o(-2), s),
      Math.min(o(-1), o(+1), s),
    );
    const fourDay = Math.max(
      Math.min(o(+3), o(+2), o(+1), s),
      Math.min(o(-1), o(+1), o(+2), s),
      Math.min(o(-2), o(-1), o(+1), s),
      Math.min(o(-3), o(-2), o(-1), s),
    );
    return parseFloat(
      (
        Math.min(s, twoDay) * TWO_DAY_DISCOUNT +
        Math.min(s, threeDay) * THREE_DAY_EXTRA_DISCOUNT +
        Math.min(s, fourDay) * FOUR_DAY_EXTRA_DISCOUNT
      ).toFixed(2),
    );
  });
  const discountedTotals = totals.map((t, i) => t - discounts[i]);
  const discountTotal = discounts.reduce((sum, d) => sum + d, 0);
  const total = totals.reduce((sum, t) => sum + t, 0) - discountTotal;
  return { totals, discounts, discountedTotals, total };
};
